<template>
  <div class="about spacer">
    <vue-headful
      title="Schedule 70, Professional Services Schedule, GSA Contractors |Clients"
      description="Fedsight offers many services, including but not limited to, management consulting and administrative support services through the General Services Administration (GSA) Professional Services Schedule (PSS)."
      url="https://www.fedsight.com/clients"
    />
    <section
      class="container-fluid serveHero d-flex align-items-center justify-content-center"
    >
      <p class="slogan internalHeader">Who We Serve</p>
    </section>

    <section class="clientList fedsightBlueBackground">
      <div class="container-fluid">
        <div class="row">
          <!-- <h2 class='fedsightYellow col-12 clientHeader'>Our Clients Include</h2> -->
          <div class="col-md-4 logoDiv">
            <img class="logo" src="../assets/gsa.png" alt="logo for GSA" />
          </div>
          <div class="col-md-4 logoDiv">
            <img class="logo" src="../assets/uscg.png" alt="logo for USCG" />
          </div>
          <div class="col-md-4 logoDiv">
            <img class="logo" src="../assets/epa.png" alt="logo for EPA" />
          </div>
          <div class="col-md-4 logoDiv">
            <img class="logo" src="../assets/doe.png" alt="logo for DOE" />
          </div>
          <div class="col-md-4 logoDiv">
            <img class="logo" src="../assets/dhs.png" alt="logo for DHS" />
          </div>
          <div class="col-md-4 logoDiv">
            <img class="logo" src="../assets/uscbp.png" alt="logo for USCBP" />
          </div>
        </div>
      </div>
    </section>

    <section
      class="fedsightGreenBackground whiteText d-flex align-items-center"
      style="height: 10rem"
    >
      <h2>Contract Vehicles</h2>
    </section>

    <section>
      <div class="triangle-down-green m-auto"></div>
      <div class="container-fluid mt-5">
        <div class="row">
          <div class="col-md-4 text-align-left pr-5 pl-1">
            <h2
              class="fedsightGreen"
              @click="openProfessional()"
              style="cursor: pointer"
            >
              GSA Professional Services Schedule
            </h2>
            <p @click="openProfessional()" style="cursor: pointer">
              <b>Contract #: </b>47QRAA19D005V
            </p>
          </div>
          <div class="col-md-8 text-align-left pr-1 pl-1">
            <p>
              Fedsight offers management and financial consulting, acquisition
              and grants management support, and business program and project
              management services through the General Services Administration
              (GSA) Professional Services Schedule (PSS): Business
              Administrative Services. Awarded Special Item Numbers (SINs)
              include SIN 541611 – Professional Services. Fedsight provides
              operating advice and assistance on administrative and management
              issues. This may include but is not limited to the
              following:Provide operating advice and assistance on
              administrative and management issues. Examples include: strategic
              and organizational planning, business process improvement,
              acquisition and grants management support, facilitation, surveys,
              assessment and improvement of financial management systems,
              financial reporting and analysis, due diligence in validating an
              agency’s portfolio of assets and related support services,
              strategic financial planning, financial policy formulation and
              development, special cost studies, actuarial services, economic
              and regulatory analysis, benchmarking and program metrics, and
              business program and project management.For a detailed description
              of services, labor categories, and labor rates, please see
              <b @click="openProfessional()" style="cursor: pointer"
                >Fedsight’s GSA PSS Contract# 47QRAA19D005V</b
              >
            </p>
          </div>
          <hr class="m-3" />
          <div class="col-md-4 text-align-left pr-5 pl-1 mobileSpacer">
            <h2
              class="fedsightGreen"
              @click="openInfo()"
              style="cursor: pointer"
            >
              GSA Information Technology Schedule 70
            </h2>
            <p @click="openInfo()" style="cursor: pointer">
              <b>Contract #: </b>47QTCA19D007S
            </p>
          </div>
          <div class="col-md-8 text-align-left pr-1 pl-1">
            <p>
              Fedsight offers information technology professional services
              through the General Services Administration (GSA) Information
              Technology Schedule (IT): IT Services. Awarded Special Item
              Numbers (SINs) include SIN 54151S - Information Technology
              Professional Services which encompasses database planning and
              design; systems analysis, integration, and design; programming,
              conversion, and implementation support; network services,
              data/records management, and testing. For a detailed description
              of services, labor categories, and labor rates, please see
              <b @click="openInfo()" style="cursor: pointer"
                >Fedsight’s GSA IT70 Contract # 47QTCA19D007S</b
              >
            </p>
          </div>
          <hr class="m-3" />
          <div class="col-md-4 text-align-left pr-5 pl-1 mobileSpacer">
            <h2 class="fedsightGreen">Cross-government Subcontracts</h2>
          </div>
          <div class="col-md-8 text-align-left pr-1 pl-1">
            <p>
              Fedsight has access to numerous agency vehicles and Governmentwide
              Acquisition Contracts (GWACs) through our extensive network of
              teaming partners. Specific Agency contracts include the
              Environmental Protection Agency, U.S. Coast Guard, U.S. Customs
              and Border Protection, General Services Administration, U.S.
              Housing and Urban Development, Department of Homeland Security,
              and Department of Energy.
            </p>
          </div>
        </div>
      </div>
    </section>

    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
import closeMenu from "../mixins/closeMenu";

export default {
  name: "clients",
  components: {
    Footer,
  },
  metaInfo: {
    link: [{ rel: "canonical", href: "https://www.fedsight.com/clients" }],
  },
  methods: {
    openInfo() {
      window.open(
        "https://www.gsaadvantage.gov/ref_text/47QTCA19D007S/0Y4H35.3TUTXT_47QTCA19D007S_47QTCA19D007S.PDF",
        "_blank"
      );
    },

    openProfessional() {
      window.open(
        "https://www.gsaadvantage.gov/ref_text/47QRAA19D005V/0Y4H2P.3TUTXD_47QRAA19D005V_47QRAA19D005V.PDF",
        "_blank"
      );
    },
  },
  mixins: [closeMenu],
  mounted() {
    document.dispatchEvent(new Event("page.rendered"));
  },
};
</script>

<style scoped>
.serveHero {
  height: 30rem;
  background-image: url(../assets/client-hero-large.jpg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.serveHeader {
  color: #fff;
  font-size: 6rem;
}
.mainParagraph {
  padding: 8rem 1.5rem;
  max-width: 80rem;
  margin: auto;
}
.logoDiv {
  padding: 4rem 0rem;
  display: flex;
  align-items: center;
  height: 20rem;
}
.clientHeader {
  padding-top: 3rem;
  font-size: 2.5rem;
}
.logo {
  max-height: 8rem;
  width: auto;
  max-width: 90%;
  margin: auto;
}
.triangle-down-green {
  width: 0;
  height: 0;
  border-left: 50px solid transparent;
  border-right: 50px solid transparent;
  border-top: 30px solid #579c5f;
}
hr {
  width: 90%;
}

@media (max-width: 767px) {
  .logoDiv {
    height: 10rem;
    padding: 1rem;
  }
  .logo {
    max-height: 70%;
  }
  .mobileSpacer {
    padding-top: 3rem;
  }
}

/* Small devices (landscape phones, 576px and up) */
@media (max-width: 576px) {
  .slogan {
    font-size: 3.5rem !important;
  }
  .serveHero {
    background-image: url(../assets/client-hero-small.jpg);
  }
}

@media (min-width: 576px) {
  .serveHero {
    background-image: url(../assets/client-hero-medium.jpg);
  }
}

@media (max-width: 768px) {
  .slogan {
    text-align: center;
    margin-left: auto;
    margin-right: auto;
  }
  .serveHero {
    justify-content: center !important;
    background-position: left bottom;
  }
}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) {
  .serveHero {
    background-image: url(../assets/client-hero-medium.jpg);
  }
}

@media (max-width: 992px) {
  .container {
    padding: 1.5rem !important;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .serveHero {
    background-image: url(../assets/client-hero-large.jpg);
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .serveHero {
    background-image: url(../assets/client-hero-extraLarge.jpg);
  }
  .slogan {
    font-size: 9rem !important;
  }
}
</style>
